import { render, staticRenderFns } from "./SharedMediaComponent.vue?vue&type=template&id=19a479c3&"
import script from "./SharedMediaComponent.vue?vue&type=script&lang=js&"
export * from "./SharedMediaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports